import * as THREE from "three";
import fragmentShader from '../../../shaders/faceDistortionMulti.frag';
import vertexShader from '../../../shaders/faceDistortionMulti.vert';

export class FaceDistortionMulti extends THREE.ShaderMaterial {

  constructor({texture}) {
    super({
      uniforms: {
        iTime: {value: 0.0},
        iResolution: {value: new THREE.Vector2(1080, 1920)},
        leftEye: {value: new THREE.Vector2(0, 0)},
        leftEyeRadius: {value: 0.065},  // better to stay below 0.1
        leftEyeZoomStrength: {value: 0.0},
        // rightEye: {value: new THREE.Vector2(0, 0)},
        // rightEyeRadius: {value: 0.065},  // better to stay below 0.1
        // rightEyeZoomStrength: {value: 0.0},
        // mouth: {value: new THREE.Vector2(0, 0)},
        // mouthRadius: {value: 0.085},  // better to stay below 0.1
        // mouthZoomStrength: {value: 0.0},
        nose: {value: new THREE.Vector2(0, 0)},
        noseRadius: {value: 0.165},  // better to stay below 0.1
        noseZoomStrength: {value: 0.0},
        chin: {value: new THREE.Vector2(0, 0)},
        chinRadius: {value: 0.390},  // better to stay below 0.1
        chinZoomStrength: {value: 0.0},

        noseSelectedEffect: {value: -1}, // possible values are -1 (disabled), 0, 1, 2
        chinSelectedEffect: {value: -1}, // possible values are -1 (disabled), 0, 1, 2

        headRoll: {value: 0.0},
        headYaw: {value: 0.0},
        headPitch: {value: 0.0},

        zoomGlobalFactor: {value: 1.0},
        iChannel0: {value: texture},
        iTexResolution: {value: new THREE.Vector2(1080, 1920)},
        // time: {value: 1.0},
        // aspect: {value: 1080/1920},
        // tex: {value: texture}, // webcam texture
        // faceBoundingBox: {value: new THREE.Vector4(0, 0, 0, 0)},
        // faceCenter: {value: new THREE.Vector3(0, 0, 0)}, // -0.5 → 0.5
        // faceQuat: {value: new THREE.Quaternion()},
        faceScale: {value: new THREE.Vector3(1, 1, 1)},
        // leftEye: { value: new THREE.Vector2(0.4, 0.5) },
        // rightEye: { value: new THREE.Vector2(0.6, 0.5) },
        // eyeRadius: { value: 0.1 },
        // eyeScale: { value: 1.3 }
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      transparent: true, // <--- IMPORTANT!
    });
  }
}
